import * as ActionTypes from './index';
import {actionCreator} from "../helpers/functions";

export const changeOperatorGroupPreferences = actionCreator(ActionTypes.CHANGE_OPERATOR_GROUP_PREFERENCES);

export const countOperatorGroups = actionCreator(ActionTypes.COUNT_OPERATOR_GROUPS);
export const countOperatorGroupsSuccess = actionCreator(ActionTypes.COUNT_OPERATOR_GROUPS_SUCCESS);
export const countOperatorGroupsFailed = actionCreator(ActionTypes.COUNT_OPERATOR_GROUPS_FAILED);

export const getOperatorGroups = actionCreator(ActionTypes.GET_OPERATOR_GROUPS);
export const getOperatorGroupsSuccess = actionCreator(ActionTypes.GET_OPERATOR_GROUPS_SUCCESS);
export const getOperatorGroupsFailed = actionCreator(ActionTypes.GET_OPERATOR_GROUPS_FAILED);

export const createOperatorGroup = actionCreator(ActionTypes.CREATE_OPERATOR_GROUP);
export const createOperatorGroupSuccess = actionCreator(ActionTypes.CREATE_OPERATOR_GROUP_SUCCESS);
export const createOperatorGroupFailed = actionCreator(ActionTypes.CREATE_OPERATOR_GROUP_FAILED);

export const deleteOperatorGroup = actionCreator(ActionTypes.DELETE_OPERATOR_GROUP);
export const deleteOperatorGroupSuccess = actionCreator(ActionTypes.DELETE_OPERATOR_GROUP_SUCCESS);
export const deleteOperatorGroupFailed = actionCreator(ActionTypes.DELETE_OPERATOR_GROUP_FAILED);

export const editOperatorGroup = actionCreator(ActionTypes.EDIT_OPERATOR_GROUP);
export const editOperatorGroupSuccess = actionCreator(ActionTypes.EDIT_OPERATOR_GROUP_SUCCESS);
export const editOperatorGroupFailed = actionCreator(ActionTypes.EDIT_OPERATOR_GROUP_FAILED);

export const copyOperatorGroupForEdit = actionCreator(ActionTypes.COPY_OPERATOR_GROUP_FOR_EDIT);
export const clearProductOperatorGroupErrorMessage = actionCreator(ActionTypes.CLEAR_PRODUCT_OPERATOR_GROUP_DELETE_ERROR_MESSAGE);
export const editOperatorGroupField = actionCreator(ActionTypes.EDIT_OPERATOR_GROUP_FIELD);




// WEBPACK FOOTER //
// ./src/actions/operatorGroups.js